import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.REPORT_SENT_ZENOSS,
  };
};


// WEBPACK FOOTER //
// ./src/reducers/report/actions/reportSent.js